<script setup lang="ts">
import { cardVariants } from "~/components/packet/variant/card/styles";

const props = defineProps<{
  variants: PacketVariant[];
  primary?: PacketVariant;
  related: Record<string, PacketVariant>;
}>();

const packet = inject(keys.currentPacket);

const classes = computed(() => cardVariants({ theme: toValue(packet)?.theme }));

provide(keys.packetVariantCard, toRef(() => ({
  classes: classes.value,
  variants: props.variants,
  primary: props.primary,
  secondary: props.primary?.relatedSubscription
    .map((sku) => props.related[sku])
    // TODO: Should we somehow support more related variants?
    .filter(truthy)?.[0],
})));
</script>

<template>
  <component
    :is="$attrs.is ?? 'div'"
    class="relative bg-white shadow-[5px_5px_var(--shadow)]"
    :class="[classes.card(), classes.shadow()]"
  >
    <slot />
  </component>
</template>
